var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.15737L11.8428 4.50025M1.32861 18.6716L4.42287 18.3278C4.80091 18.2858 4.98994 18.2648 5.16661 18.2076C5.32336 18.1568 5.47253 18.0851 5.61008 17.9944C5.76511 17.8922 5.89959 17.7577 6.16855 17.4887L18.2428 5.41453C19.2527 4.40465 19.2527 2.7673 18.2428 1.75741C17.2329 0.74753 15.5956 0.747529 14.5857 1.75741L2.51144 13.8316C2.24248 14.1006 2.10799 14.2351 2.00576 14.3901C1.91506 14.5276 1.84337 14.6768 1.79262 14.8336C1.73543 15.0102 1.71442 15.1993 1.67242 15.5773L1.32861 18.6716Z",
    stroke: "#B8135D",
    strokeWidth: 1.82856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.b10967a536fee7270013f7497eb98042.svg";
export { ForwardRef as ReactComponent };